// removed by extract-text-webpack-plugin
module.exports = {"PageItem":"_3MqExJGCIyb70tElW_Rwlr","Active":"_2z23DU-XZ8jeWJrCnz6dJH","Pagination":"_2ZaB9cB--NV6PuiuxzMQkI"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Pagination/style.css
// module id = 1361
// module chunks = 0